import React from 'react';

import { useI18n } from 'i18n';
import { ITepOfficer } from 'types/tep';
import { IInfoTableColumn } from 'types/info-table';
import { RowSelectionCheckbox } from 'components/organisms/tables/info-table/row-selection-checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { selectedOfficersSelector } from 'core/redux/selectors/tep';
import { actions } from 'core/redux/api/veta/tep/officers';

export const useNotifyContactsColumns = () => {
  const { fc } = useI18n();
  const dispatch = useDispatch();
  const { selected, officers } = useSelector(selectedOfficersSelector);

  const onSelect = (row: ITepOfficer) => {
    const isSelected = !!selected.find((officer) => officer.id === row.id);

    if (isSelected) {
      const filtered = selected.filter((officer) => officer.id !== row.id);

      dispatch(actions.select({ officers: filtered }));
    }

    if (!isSelected) {
      dispatch(actions.select({ officers: [...selected, row] }));
    }
  };

  return [
    {
      header: (
        <RowSelectionCheckbox isHeader isChecked={selected.length === officers.length} onClick={() => console.log(1)} />
      ),
      accessorKey: 'selection',
      cell: ({ row }) => (
        <RowSelectionCheckbox
          isChecked={!!selected.find((officer) => officer.id === row.id)}
          onClick={() => {
            onSelect(row);
          }}
        />
      ),
      width: 60,
      minWidth: 60,
    },
    { header: fc('Contact Number'), accessorKey: 'phone', width: 200, minWidth: 200 },
    { header: fc('remarks'), accessorKey: 'remarks', minWidth: 120 },
  ] as IInfoTableColumn<ITepOfficer>[];
};
